const t = {
  name: "Info",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.25 7.25C13.25 7.94 12.69 8.5 12 8.5C11.31 8.5 10.75 7.94 10.75 7.25C10.75 6.56 11.31 6 12 6C12.69 6 13.25 6.56 13.25 7.25Z" fill="currentColor"/>
<path d="M9 10H13V15H15V17H9V15H11V12H9V10Z" fill="currentColor"/>
<path d="M12 1C5.92772 1 1 5.92772 1 12C1 18.0723 5.92772 23 12 23C18.0723 23 23 18.0723 23 12C23 5.92772 18.0723 1 12 1ZM3 12C3 7.03228 7.03228 3 12 3C16.9677 3 21 7.03228 21 12C21 16.9677 16.9677 21 12 21C7.03228 21 3 16.9677 3 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Info
};
